import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Checkbox } from 'wix-style-react'
import { HELVETICA, BLUE, LIGHT_BLUE } from '../../../../styles'

const Container = styled.div`
  flex: 1;
  margin-left: 10px;
  margin-right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  _background-color: #c2c2c2;
  cursor: default;
  ${HELVETICA}
`
const CheckboxText = styled.div`
  font-size: 12px;
  font-weight: 100;
  letter-spacing: 0.3px;
  ${HELVETICA}
`
const Button = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 77px;
  height: 23px;
  border-radius: 6.6px;
  background-color: ${BLUE};
  color: white;
  font-size: 8.8px;
  letter-spacing: 0.6px;
  cursor: pointer;
  ${HELVETICA}

  &:hover {
    background-color: ${LIGHT_BLUE}
  }

`

const IPCHeader = ({isVisible, onClick, onChangeVisible}) => {
  return (
    <Container>
      <Checkbox
        checked={isVisible}
        onChange={onChangeVisible}
      >
        <CheckboxText>Visible</CheckboxText>
      </Checkbox>
      <Button onClick={onClick}>
        Tag Products
      </Button>
    </Container>
  )
}

IPCHeader.defaultProps = {
  onClick: () => null,
  onChangeVisible: () => null
}


IPCHeader.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
  onChangeVisible: PropTypes.func
}

export default IPCHeader



// WEBPACK FOOTER //
// ./src/components/editor/insta/instaTagPosts/instaPostCard/IPCHeader.js